import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../../context/Profile.context';
import { Box, DateField, Label, NumberField, TextField, SectionTitle } from '@otcmarketsgroup/otcm-ui-lib';
import { getLimitedInteger } from '../../../utils/validations';
import { testIds } from '../../../constants/testIds';

const MAX_EMPLOYEES_LENGTH = 8;

const GeneralInformation = () => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const isReadOnly = profileState.readOnly;

    const onValueChanged = updatedObj => {
        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'companyInfo',
            payload: updatedObj.companyInfo
        });
    };

    const handleNumberOfEmployees = (field, e) => {
        const value = getLimitedInteger(e.target.value, MAX_EMPLOYEES_LENGTH);
        onValueChanged({ companyInfo: { ...profileData.companyInfo, [field]: value } });
    };

    return <Box display='grid' gap={2} gridTemplateColumns={{ desktop: 'repeat(6, 1fr)', mobile: '1fr' }}>
        <Box gridColumn='span 6'>
            <SectionTitle noUnderline>General Information</SectionTitle>
        </Box>
        <Box gridColumn='span 6' data-testid={testIds.companyInfo.general.businessDesc}>
            <TextField
                id='businessDesc'
                type="text"
                label="Business Description"
                placeholder='Enter text here'
                value={profileData.companyInfo.businessDesc || ''}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, businessDesc: e.target.value } })}
                multiline
                maxLength={1500}
                error={!profileData.companyInfo.businessDesc}
                helperText={!profileData.companyInfo.businessDesc ? 'Required' : undefined}
                readOnly={isReadOnly}
                showCharCounter={!isReadOnly}
            />
        </Box>
        <Box gridColumn='span 6' data-testid={testIds.companyInfo.general.facilitiesDesc}>
            <Label tooltipDark tooltipSubtitle="Describe the assets, properties or facilities owned, used or leased by the issuer. Give the location of the principal plants and other property of the issuer and describe the condition of the properties. IF the issuer does not have complete ownership or control of the property (for example, it others also own the property or if there is a mortgage on the property), describe the limitations on the ownership.">Facilities Description</Label>
            <TextField
                id='facilitiesDesc'
                type="text"
                value={profileData.companyInfo.facilitiesDesc || ''}
                placeholder='Enter text here'
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, facilitiesDesc: e.target.value } })}
                multiline
                maxLength={1500}
                error={!profileData.companyInfo.facilitiesDesc}
                helperText={!profileData.companyInfo.facilitiesDesc ? 'Required' : undefined}
                readOnly={isReadOnly}
                showCharCounter={!isReadOnly}
            />
        </Box>
        <Box gridColumn='span 6' data-testid={testIds.companyInfo.general.productServiceDesc}>
            <TextField
                id='productServiceDesc'
                type="text"
                label="Product & Services Description"
                placeholder='Enter text here'
                value={profileData.companyInfo.productServiceDesc || ''}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, productServiceDesc: e.target.value } })}
                multiline
                maxLength={1500}
                error={!profileData.companyInfo.productServiceDesc}
                helperText={!profileData.companyInfo.productServiceDesc ? 'Required' : undefined}
                readOnly={isReadOnly}
                showCharCounter={!isReadOnly}
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.general.numEmployees}>
            <NumberField
                id='numberOfEmployees'
                label="# of Employees"
                showClearButton
                showStepper
                placeholder='XX'
                min={0}
                maxLength={MAX_EMPLOYEES_LENGTH}
                value={profileData.companyInfo.numberOfEmployees ?? ''}
                readOnly={isReadOnly}
                error={profileData.companyInfo.numberOfEmployees == null || profileData.companyInfo.numberOfEmployees === ''}
                helperText={(profileData.companyInfo.numberOfEmployees == null || profileData.companyInfo.numberOfEmployees === '') ? 'Required' : undefined}
                onChange={e => handleNumberOfEmployees('numberOfEmployees', e)}
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.general.numEmployeesAsOf}>
            <DateField
                id='numberOfEmployeesAsOf'
                type="date"
                label="# of Employees As Of"
                showClearButton
                error={!profileData.companyInfo.numberOfEmployeesAsOf}
                helperText={!profileData.companyInfo.numberOfEmployeesAsOf ? 'Required' : undefined}
                value={profileData.companyInfo.numberOfEmployeesAsOf || ''}
                onSelectDate={date => onValueChanged({ companyInfo: { ...profileData.companyInfo, numberOfEmployeesAsOf: date } })}
                readOnly={isReadOnly}
            />
        </Box>
    </Box>;
};

export default GeneralInformation;
